import WorkspaceTeam from "./workspace-team";
import {useState} from "react";
import {useDispatch, useSelector} from "react-redux";

export function useWorkspaceTeam() {
    const [loading, setLoading] = useState(false);
    const {user} = useSelector(state => state.auth);
    const dispatch = useDispatch();
    const getWorkspaceTeams = async (workspaceId)=>{
        setLoading(true);
        try {
            const workspaceTeam = new WorkspaceTeam();
            const query = {
                filters: {
                    $and:[
                        {workspace:{$eq: workspaceId}},
                        // {members: {id:{$eq: user.id}}}
                    ],
                },
                populate:"*"
            }
            const _data = await workspaceTeam.getAll(query);
            setLoading(false);
            return _data.data.map(d=>(d.name))
        }catch (e) {
            console.log(e)
            setLoading(false);
        }

    }


    return {getWorkspaceTeams};
}
